import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './OtherFilings.less';

export class OtherFilings extends Component {
  render() {
    const { otherFilings } = this.props;
    const header = 'Other Filings by Same Debtor(s)';
     
    if (otherFilings.empty) {
       return (<div> </div>);
    }
    const rows = otherFilings.map((item, key) => {
      const debtor = item.debtor || {};
      const cs = item.case || {};
      const link = `/filings/${cs.case_uuid}-`;

      return (
        <tr key={`case-${key}`}>
          <td><a href={link}>{ cs.case_code }</a> <span> { cs.case_name || '' } </span></td>
          <td>{ debtor.name || '' }</td>
        </tr>
        );
      });

      return (
        <div className="other-filings">
          <h2 className="case-label"></h2>
          <table className="sticky-enabled tablesorter">
            <thead>
              <tr>
                <th><span>{ header } Cases</span></th>
                <th><span>Debtor(s)</span></th>
              </tr>
            </thead>
            <tbody>
              { rows }
            </tbody>
          </table>
        </div>
      );
  }
}

export default OtherFilings;



/** WEBPACK FOOTER **
 ** ./src/components/case/associated_cases/OtherFilings.js
 **/